import Axios from 'axios';
import { ERROR_STRING_COLOR } from '../utilities/constants/Constants';
import { string } from '../localization';
import actions from '../redux/actionTypes';

const interceptor = store => {
  Axios.interceptors.response.use(null, error => {
    const dict = {
      header: `${error.response.status} Error!`,
      description: error.response.statusText,
      stringColor: ERROR_STRING_COLOR,
      onclick: null,
      buttonTitles: { finish: string.OK_KEY, cancel: '' }
    };

    store.dispatch({
      type: actions.SET_DIALOGUE_PARAMS,
      payload: {
        info: dict
      }
    });
    store.dispatch({
      type: actions.SET_DIALOGUE_FLAG,
      payload: {
        dialogueFlag: true
      }
    });
    return Promise.reject(error);
  });
};

export default {
  interceptor
};
